// This calculation is used for the feature flag reviews_weighted_average activated for GT

const NORMALIZED_SCORE = 10
type RatingValue = { value: number | null; maxScale: number }

const normalizeScore = (score: number, maxScale: number) => {
  return (score * NORMALIZED_SCORE) / maxScale
}

export const calculateRatingAverageScore = (values: RatingValue[]) => {
  const score =
    values
      .map(({ value, maxScale }) => normalizeScore(value || 0, maxScale))
      .reduce((sum, normalizedValue) => sum + normalizedValue, 0) / values.length

  const rawScore = values.length ? score : undefined
  const formattedScore = rawScore ? score.toFixed(2) : undefined
  const displayScore = formattedScore ? `${formattedScore}/${NORMALIZED_SCORE.toFixed(2)}` : '-'

  return {
    rawScore,
    formattedScore,
    displayScore,
  }
}
